import {createEnum} from "./EnumArray"

// 公告状态
export const NOTICE_STATUS = createEnum([
  {label: "启用", value: "open"},
  {label: "禁用", value: "close"},
])
